import { BaseModel } from "sjs-base-model";
import RiskModel from "./RiskModel";

export default class AssicurazioneModel extends BaseModel {
    public readonly lifeRisk: RiskModel | undefined = undefined;
    public readonly creditRisk: RiskModel | undefined = undefined;

    constructor(data: Partial<AssicurazioneModel>) {
        super();

        this.update(data);
    }
}
